export function getEmptyAdmittanceRecord (isRequired = false) {
  return {
    id: null,
    key: null,
    name: null,
    type: null,

    qualificationType: null,
    qualificationTypeKey: null,
    isAdmittance: false,
    isRequired: isRequired,
    isHandAdded: true,

    level: null,
    qualificationPosition: null,
    docN: null,
    qualificationDocumentType: null,
    startValidTime: null,
    endValidTime: null,

    document: []
  }
}

export function deleteDocumentFromAdmittanceRecord (record) {
  record.startValidTime = null
  record.endValidTime = null
  record.qualificationPosition = null
  record.docN = null
  record.document = []
  record.qualificationDocumentType = null
  record.qualificationDocumentTypeAlias = null
}

export const qualificationDocumentTypeOptions = [
  {
    label: 'удостоверение',
    value: 'card'
  },
  {
    label: 'протокол',
    value: 'protocol'
  }
]
